import { render, staticRenderFns } from "./DisplayActivationKey.vue?vue&type=template&id=0754c304&v-slot%3Aactivator=%7B%20on%20%7D"
import script from "./DisplayActivationKey.vue?vue&type=script&lang=ts"
export * from "./DisplayActivationKey.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports